import React from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../../../common/head-container';

const AlreadyRegistered = ({
  setScreenNumber,
  telegramLink,
  handleNextButtonClick
}) => {
  const handleContentButtonClick = () => {
    sessionStorage.setItem('r_b', 'false');
    handleNextButtonClick();
  };

  return (
    <div className={styles.container}>
      <div className={styles.headContainer}>
        <HeadContainer
          setScreenNumber={setScreenNumber}
          telegramOnly
          customTelegramLink={telegramLink}
        />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>Супер!</p>
        <p className={styles.description}>
          Бачимо, що ти вже підтвердив свій вік раніше.
          <br></br>
          <br></br>
          Не гай часу, переходь до контенту.
        </p>
        <img
          className={styles.shapes}
          src="/images/ua-lm-1test-auth/super-shapes.svg"
          alt=""
        />
        <button
          className={styles.nextButton}
          onClick={handleContentButtonClick}
        >
          <img
            className={styles.buttonGlowTop}
            src="/images/ua-lm-1test-auth/button-glow-top.svg"
            alt=""
          />
          <img
            className={styles.buttonGlowBottom}
            src="/images/ua-lm-1test-auth/button-glow-bottom.svg"
            alt=""
          />
          <span>Далі</span>
        </button>
      </div>
    </div>
  );
};

export default AlreadyRegistered;
